import { Badge, Flex, Text } from '@chakra-ui/react'

import { formatDateTime } from '../../../helpers'
import { statuses } from './RequestConsts'

interface ILogs {
  changed_in: string
  old_status: string
  new_status: string
  user: {
    name: string
  }
}

interface IRequestStatusLogProps {
  logs: ILogs[]
}

export function RequestStatusLog({ logs }: IRequestStatusLogProps) {
  return (
    <>
      {(logs == undefined || logs.length === 0) && (
        <Text textAlign="center">Sem alterações de status registradas.</Text>
      )}
      {logs != undefined &&
        logs.map((log, index) => (
          <Flex key={index} mb={2} alignItems="center">
            <Badge
              colorScheme={statuses?.[log.old_status] ? statuses[log.old_status].color : 'gray'}
              color={statuses?.[log.old_status] ? statuses[log.old_status].textColor : 'black'}
              mr={1}
            >
              {statuses?.[log.old_status] ? statuses[log.old_status].text : log.old_status}
            </Badge>
            &#8594;
            <Badge
              colorScheme={statuses?.[log.new_status] ? statuses[log.new_status].color : 'gray'}
              color={statuses?.[log.new_status] ? statuses[log.new_status].textColor : 'black'}
              ml={1}
              mr={2}
            >
              {statuses?.[log.new_status] ? statuses[log.new_status].text : log.new_status}
            </Badge>
            <Text variant="caption" as="span" ml={2}>
              por <strong>{log.user.name}</strong> em {formatDateTime(log.changed_in)}
            </Text>
          </Flex>
        ))}
    </>
  )
}
